import React, { useCallback, useRef, useState } from 'react';
import 'react-aspect-ratio/aspect-ratio.css';
import { DisplayContext, DisplayOptions, useUserSettingsContext } from 'contexts';
import { LiveKitRoom } from 'features/Room/LiveKitRoom';
import { Room, RoomEvent } from 'livekit-client';
import { STAGE_LAYOUT, StageLayout } from '../consts';
import { RoomContainer } from './view';

export const RecordPage: React.FC = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token') || '';
    const wssUrl = params.get('url') || '';

    const isRecording = useRef(false);

    const [displayOptions, setDisplayOptions] = useState<DisplayOptions>({
        stageLayout: STAGE_LAYOUT.GRID,
    });

    const userConfig = useUserSettingsContext();
    userConfig.setAudioEnabled(false);
    userConfig.setVideoEnabled(false);

    const setStageLayout = useCallback((stageLayout: StageLayout) => {
        setDisplayOptions((prev) => {
            if (prev.stageLayout === stageLayout) {
                return prev;
            }

            return { ...prev, stageLayout };
        });
    }, []);

    const onConnected = useCallback(
        (room: Room) => {
            if (room.remoteParticipants.size > 0) {
                isRecording.current = true;
                console.log('START_RECORDING');
            }
            room.on(RoomEvent.ParticipantConnected, () => {
                if (!isRecording.current && room.remoteParticipants.size > 0) {
                    console.log('START_RECORDING');
                    isRecording.current = true;
                }
            });
            room.on(RoomEvent.ParticipantDisconnected, () => {
                if (room.remoteParticipants.size === 0 && isRecording.current) {
                    console.log('END_RECORDING');
                }
            });
        },
        [isRecording],
    );

    return (
        <DisplayContext.Provider value={{ ...displayOptions, setStageLayout }}>
            <RoomContainer>
                <LiveKitRoom url={wssUrl} token={token} hasRecorder onConnected={onConnected} />
            </RoomContainer>
        </DisplayContext.Provider>
    );
};
